'use client';

import { Toaster } from 'sonner';

export default function ToastContainer(props) {
    return <Toaster {...props} />;
}
